import { FilterFn } from '@tanstack/react-table';

declare module '@tanstack/table-core' {
  interface FilterFns {
    facilityIds: FilterFn<unknown>
  }
}

const facilityIds: FilterFn<any> = (row, columnId, value: number[], addMeta) => {
  if (value == null || value.length == 0) {
    return true;
  }

  // Make a rudimentary guess of the facility ID location for now
  let facilityId = row.original.facility?.id || row.original.inmate?.facility?.id;

  return value.indexOf(facilityId) > -1;
};

export default facilityIds;
